
import Popper from 'element-ui/lib/utils/vue-popper';

export default {
  name: 'WkSelectDropdown',

  componentName: 'WkSelectDropdown',

  mixins: [Popper],

  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },

    boundariesPadding: {
      type: Number,
      default: 0
    },

    popperOptions: {
      type: Object,
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    },

    visibleArrow: {
      type: Boolean,
      default: false
    },

    appendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      minWidth: '300px'
    };
  },


  computed: {
    popperClass: function popperClass() {
      return this.$parent.popperClass;
    }
  },

  watch: {
    // '$parent.inputWidth'() {
    //   this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px'
    // }
  },

  mounted: function mounted() {
    var _this = this;

    this.referenceElm = this.$parent.$el;
    this.$parent.popperElm = this.popperElm = this.$el;
    this.$on('updatePopper', function () {
      if (_this.$parent.visible) _this.updatePopper();
    });
    this.$on('destroyPopper', this.destroyPopper);
  }
};